import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { uiActions } from './ui.actions';
import { selectSidebarCollapsed } from './ui.selectors';

@Injectable({ providedIn: 'root' })
export class UIFacade {
  private readonly store = inject(Store);

  sidebarCollapsed$ = this.store.select(selectSidebarCollapsed);

  setSidebarCollapsed(collapsed: boolean) {
    this.store.dispatch(uiActions.setSidebarCollapsed({ collapsed }));
  }
}
